import { CreateOrEditDeploymentFreeze } from "./CreateOrEditDeploymentFreeze";
export function CreateDeploymentFreezePage() {
    return <CreateOrEditDeploymentFreeze create={true}/>;
}
